import React from 'react'
import { observer } from 'mobx-react-lite'
import { formatDistanceToNow } from 'date-fns'
import { Person } from 'react-bootstrap-icons'
import LinkifiedText from '../LinkifiedText'

export default observer(function CampaignInfluencerCommentItem({ comment, isClientThread }) {
  return (
    <div className='flex items-start min-w-0'>
      <div className='p-3 shrink-0'>
        {comment.project_manager_id
          ? <img className="h-12 w-12 rounded-full mx-3 ml-4" src={comment.creator_avatar} />
          : <Person className="h-12 w-12 rounded-full mx-3 ml-4 p-2 bg-rb-green text-white" />
        }
      </div>

      <div className='bg-gray-100 dark:bg-rb-dark-mode-lighter m-2 p-3 rounded-lg flex-grow min-w-0 max-w-[450px]'>
        <div className="flex justify-between items-start gap-2">
          <div className="flex flex-wrap items-baseline gap-x-2 min-w-0">
            <h4 className='font-bold rb-text-primary truncate'>{comment.creator_name || 'Advertiser'}</h4>
            <p className='rb-text-muted whitespace-nowrap'>{formatDistanceToNow(new Date(comment.created_at), { addSuffix: true })}</p>
          </div>
          <div className='flex shrink-0 gap-2 items-center px-2 py-1 rounded-full bg-gray-200 dark:bg-rb-dark-mode'>
            <div className="h-2 w-2 rounded-full" style={{ backgroundColor: isClientThread ? '#2563EB' : '#EAB308'}} />
            <p className='text-xs rb-text-primary'>{isClientThread ? 'External' : 'Internal'}</p>
          </div>
        </div>
        <div className='mt-1 rb-text-secondary'>
          <LinkifiedText text={comment.message} />
        </div>
      </div>
    </div>
  )
})
